import { AxiosStatic } from "axios";
import { createContext, useContext, useState } from "react";

import Global from "../commons/global";
import { IReaction, IUserComment } from "../commons/interfaces";

interface ICommentContext {
    axios: AxiosStatic;
    clientId: string;
    tenantCode: string;
    serviceCode: string;
    organizationId: string;
    userLogin: IUserComment;

    reload?: number;
    isManager: boolean;
    referenceId: string;
    hiddenComment: boolean;
    reactionIcons?: IReaction[];
    setReload?: React.Dispatch<React.SetStateAction<number>>;
    onClickShowProfile?: (data: IUserComment) => void;
}

export const CommentContext = createContext<ICommentContext>(null!);

export const useCommentContext = () => useContext(CommentContext);

interface IProps {
    value: ICommentContext;
    children: React.ReactNode;
}

export const CommentProvider = ({ children, value }: IProps) => {
    const [reload, setReload] = useState<number>(0);

    Global.axios = value.axios;

    return (
        <CommentContext.Provider
            value={{
                ...value,
                reload,
                setReload,
            }}
        >
            {children}
        </CommentContext.Provider>
    );
};
